export const GA_PROPERTY = `UA-128414423-1`;
export const GA_DISABLE_STR = `ga-disable-${GA_PROPERTY}`;
